var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentCierreId == "",
                  expression: "currentCierreId == ''"
                }
              ],
              staticClass: "btn-info",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v("Consultar valores")
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentCierreId == "" && _vm.cierreConsultado,
                  expression: "currentCierreId == '' && cierreConsultado"
                }
              ],
              staticClass: "btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.cerrarCaja }
            },
            [
              _c("i", { staticClass: "fa fa-check" }),
              _c("span", [_vm._v("Cerrar caja")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentCierreId !== "",
                  expression: "currentCierreId !== ''"
                }
              ],
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.exportar }
            },
            [_c("i", { staticClass: "fa fa-file-excel-o" }), _vm._v("Exportar")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.verListado }
            },
            [
              _c("i", { staticClass: "fa fa-table" }),
              _c("span", [_vm._v("Listado de cierres")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "fecha",
                      locale: "es",
                      "no-label": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD HH:mm:ss",
                      formatted: "YYYY-MM-DD HH:mm:ss",
                      label: "Seleccione fecha..."
                    },
                    model: {
                      value: _vm.form.fecha,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fecha", $$v)
                      },
                      expression: "form.fecha"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Fecha")])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.bodegas.length > 1,
                  expression: "bodegas.length > 1"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        id: "bodega_id",
                        options: _vm.bodegas,
                        label: "descripcion"
                      },
                      on: { input: _vm.inputBodega },
                      model: {
                        value: _vm.selectedBodega,
                        callback: function($$v) {
                          _vm.selectedBodega = $$v
                        },
                        expression: "selectedBodega"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bodega" } }, [
                      _vm._v("Sucursal")
                    ])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: "",
                      vMoney: "",
                      format: _vm.money,
                      placeholder: "Ingrese un valor...",
                      id: "valor_inicial"
                    },
                    model: {
                      value: _vm.form.valor_inicial,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "valor_inicial", $$v)
                      },
                      expression: "form.valor_inicial"
                    }
                  },
                  [
                    _vm._v(
                      "\n                            Valor Inicial en Caja\n                        "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c(
          "div",
          {
            staticClass: "table-responsive",
            staticStyle: { "max-height": "300px" }
          },
          [
            _c("table", [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.recaudadores, function(recaudador, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(recaudador.nombre) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.moneyFormat(recaudador.recaudacion)) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.moneyFormat(recaudador.almuerzo)) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.moneyFormat(recaudador.peaje)) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.moneyFormat(recaudador.gasolina)) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.moneyFormat(recaudador.pago_carro)) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.moneyFormat(recaudador.otros)) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.moneyFormat(recaudador.deposito)) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moneyFormat(_vm.calcularEntrega(recaudador))
                          )
                        )
                      ])
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _c("th", { attrs: { scope: "row" } }, [
                    _vm._v(
                      "\n                                Totales\n                            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.moneyFormat(_vm.totalRecaudacion)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.moneyFormat(_vm.totalAlmuerzo)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.moneyFormat(_vm.totalPeaje)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.moneyFormat(_vm.totalGasolina)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.moneyFormat(_vm.totalPagoCarro)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.moneyFormat(_vm.totalOtros)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.moneyFormat(_vm.totalDeposito)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.moneyFormat(_vm.calcularEntregaTotal()))
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(
                  "Gastos en ruta: " +
                    _vm._s(_vm.moneyFormat(_vm.totalGastosRuta))
                )
              ])
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col-xs-12 col-md-8" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card__content" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.totalGastos == 0,
                      expression: "totalGastos == 0"
                    }
                  ]
                },
                [_vm._m(5)]
              ),
              _vm._v(" "),
              _vm._l(_vm.gastos, function(arrayGastos, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "table-responsive",
                    staticStyle: { "max-height": "300px" }
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(index))]),
                    _vm._v(" "),
                    _c("table", [
                      _vm._m(6, true),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(arrayGastos, function(gasto, key) {
                          return _c("tr", { key: "gasto" + key + index }, [
                            _c("td", [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(gasto.fecha) +
                                  "\n                                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(gasto.detalle) +
                                  "\n                                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(_vm.moneyFormat(gasto.valor)) +
                                  "\n                                    "
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  ]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__title" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", [
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.ingresos, function(ingreso, index) {
                      return _c("tr", { key: index }, [
                        _c("th", { attrs: { scope: "row" } }, [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(ingreso.rubro) +
                              "\n                                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(_vm.moneyFormat(ingreso.valor)) +
                              "\n                                    "
                          )
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v(
                          "\n                                        Total de ingresos (+)\n                                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.moneyFormat(_vm.totalIngresos)))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v(
                          "\n                                        Total gastos (-)\n                                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.moneyFormat(_vm.totalGastos)))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _vm._v(
                          "\n                                        Total en caja\n                                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.moneyFormat(_vm.total)))
                        ])
                      ])
                    ])
                  ],
                  2
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Cierre de Caja")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h3", [_vm._v("Información de cierre")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Rubros")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Colaborador")]),
        _vm._v(" "),
        _c("th", [_vm._v("Recaudación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Viáticos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Peaje")]),
        _vm._v(" "),
        _c("th", [_vm._v("Combustible")]),
        _vm._v(" "),
        _c("th", [_vm._v("Alq/Veh.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Otros")]),
        _vm._v(" "),
        _c("th", [_vm._v("Depósitos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Entrega")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Gastos/Ingresos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("No se ha encontrado gastos.")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Fecha")]),
        _vm._v(" "),
        _c("th", [_vm._v("Detalle")]),
        _vm._v(" "),
        _c("th", [_vm._v("Valor")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-406c5beb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-406c5beb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/administrativo/CierreCaja.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-406c5beb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/administrativo/CierreCaja.vue
// module chunks = 0